import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "error-row"
}
const _hoisted_2 = { class: "buy-now-row" }
const _hoisted_3 = { class: "price-container" }
const _hoisted_4 = { class: "price-header" }
const _hoisted_5 = { class: "price-value" }
const _hoisted_6 = { class: "buy-field-container" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "button-column" }
const _hoisted_9 = ["data-action", "disabled"]

import { type PropType, computed, ref } from "vue";
import CoolInput from "../../shared/CoolInput.vue";
import CoolButton from "../../shared/CoolButton.vue";
import { type AuctionProduct } from "./types";
import { createCurrencyFormatter } from "../common/amount-format";
import axios from "axios";
import { useRevealActions } from "../../../../state/reveal-actions";
import labels from "../../shared/labels";
import stringify from "qs/lib/stringify";
import { checkLoggedIn } from "./login";


export default /*@__PURE__*/_defineComponent({
  __name: 'buy-now-form',
  props: {
    product: {
        type: Object as PropType<AuctionProduct>,
        required: true,
    },
},
  setup(__props) {

const revealActions = useRevealActions();

const formatter = createCurrencyFormatter();
const props = __props;

const errors = ref<string[]>([]);
const quantity = ref<number>(1);
const loading = ref(false);
const disabled = computed(() => loading.value);

function formatAmounts(value: number) {
    return formatter.format(value);
}

function disableDecimalKeys(e: Event) {
    if (!(e instanceof KeyboardEvent)) {
        return;
    }
    if (
        //["Comma","Period", "Slash", "NumpadAdd","NumpadSubtract", "Minus", "KeyE"].includes(e.code)
        [",", ".", "+", "e"].includes(e.key)
    ) {
        e.preventDefault();
    }
}

async function submitBuy() {
    if (loading.value) return;
    loading.value = true;
    try {
        const value = quantity.value;
        if (typeof value !== "number" || isNaN(value)) {
            throw new Error("Invalid quantity");
        }

        const estimate = props.product.estimatedPrice;
        if (typeof estimate == "number" && estimate > 0 && value >= estimate) {
            const confirmLabel =
                labels.frontendProductpage.auction
                    .bidAboveEstimatedValueConfirmation;
            if (
                typeof confirmLabel === "string" &&
                confirmLabel.length > 0 &&
                !confirm(
                    labels.frontendProductpage.auction
                        .bidAboveEstimatedValueConfirmation
                )
            ) {
                return;
            }
        }
        const response = await axios.post<
            | {
                  Success: "True";
                  Message: string;
              }
            | {
                  Success: "Fail" | "False";
                  Message: string;
              }
        >(
            "/auctionProduct/BuyNow",
            stringify({
                productId: props.product.id,
                noOfItems: quantity.value,
            })
        );

        const data = response.data;
        if (data.Success !== "True") {
            if (data.Message != null) {
                console.error(data.Message);
                errors.value = [data.Message];
            } else {
                errors.value = ["Unknown error"];
            }
        } else {
            location.assign(data.Message);
        }
    } finally {
        loading.value = false;
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"]))
  }, [
    (errors.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(errors.value, (error) => {
            return (_openBlock(), _createElementBlock("div", null, _toDisplayString(error), 1 /* TEXT */))
          }), 256 /* UNKEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(labels).frontendProductpage.auction[
                            __props.product.hasLoserOffer
                                ? "buyNowPrice_loserOffer"
                                : "buyNowPrice"
                        ]) + ": ", 1 /* TEXT */),
        _createElementVNode("span", _hoisted_5, _toDisplayString(formatAmounts(__props.product.buyPrice)), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(CoolInput, { "number-arrows": false }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("input", {
              type: "number",
              onFocus: _cache[0] || (_cache[0] = ($event: any) => (_unref(checkLoggedIn)($event))),
              onInput: _cache[1] || (_cache[1] = ($event: any) => (_unref(checkLoggedIn)($event))),
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((quantity).value = $event)),
              min: "1",
              step: "1",
              disabled: disabled.value,
              onKeypress: _cache[3] || (_cache[3] = ($event: any) => (
                            _unref(checkLoggedIn)($event) && disableDecimalKeys($event)
                        )),
              class: "quantity-field"
            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_7), [
              [
                _vModelText,
                quantity.value,
                void 0,
                { number: true }
              ]
            ])
          ], undefined, true),
          _: 1 /* STABLE */
        })
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(CoolButton, {
          theme: "turqoise",
          busy: loading.value,
          "busy-size": 26
        }, {
          default: _withCtx(() => [
            _createElementVNode("button", {
              type: "button",
              class: "submit-buy",
              "data-action": 
                            _unref(revealActions).revealActions ? 'buy-now' : undefined
                        ,
              disabled: disabled.value,
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(checkLoggedIn)($event) && submitBuy()))
            }, _toDisplayString(_unref(labels).frontendProductpage.auction[
                                __props.product.hasLoserOffer
                                    ? "buyNowButton_loserOffer"
                                    : "buyNowButton"
                            ]), 9 /* TEXT, PROPS */, _hoisted_9)
          ], undefined, true),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["busy"])
      ])
    ])
  ], 32 /* NEED_HYDRATION */))
}
}

})